import * as React from "react";
import {Route} from "react-router-dom";
import {Redirect} from "react-router";
import {Api} from "../../_helpers/api";
import MyStylesContainer from "../../style/containers/MyStylesContainer";
import SpecialsContainer from "../../special/containers/SpecialsContainer";
import SpecialItemContainer from "../../special/containers/SpecialItemContainer";
import ActivityFeedContainer from "../../activityFeeds/containers/ActivityFeedContainer";
import {ConversationsRoutes, FeedsRoutes, SearchRoutes, ShopsRoutes, SpecialsRoutes, StylesRoutes} from "../../routes";
import {Dispatch} from "react-redux";
import {initializeStyle, initializeStyles, saveScrollPosition} from "../../style/middlewares";
import {fetchCommentsByStyle} from "../../comment/middlewares";
import {initializeSpecial, initializeSpecials, initializeSpecialsType} from "../../special/middlewares";
import ShopListContainer from "../../shop/container/ShopListContainer";
import {fetchUser} from "../../user/middlewares";
import MyProfileContainer from "../../user/container/MyProfileContainer";
import {History, Location} from "history";
import StyleContainer from "../../style/containers/StyleContainer";
import ShopViewContainer from "../../shop/container/ShopViewContainer";
import BoothProfileContainer from "../../booth/containers/BoothProfileContainer";
import SearchContainer from "../../search/containers/SearchContainer";
import {searchFromUrl} from "../../search/middlewares";
import AddBoothContainer from "../../booth/containers/AddBoothContainer";
import {initializeFeeds} from "../../activityFeeds/middlewares";
import * as queryString from "query-string";
import {currentUserIsLoggedIn, to_url, toggleBodyScroll} from "../../_helpers/utils";
import ConversationsContainer from "../../message/containers/ConversationsContainer";
import MessagesContainer from "../../message/containers/MessagesContainer";
import {initializeConversation, initializeNewConversation} from "../../message/middlewares";
import {refreshShops} from "../../shop/middlewares";

interface Props {
    initialized: boolean;
    location: Location;
    history: History;
    dispatch: Dispatch<any>;
}

export default class RouterComponent extends React.Component<Props, any> {
    refresh: boolean;
    pop: boolean;
    scrollEventHandler:any;
    rendered: boolean;

    constructor(props) {
        super(props);
        this.refresh = true;
        this.rendered = false;
    }

    componentWillReceiveProps(nextProps) {
        const {history, location} = nextProps;
        this.pop = history.action == 'POP';

        if (location.state)
            this.refresh = location.state.refresh === true || (history.action != 'POP' && location.state.refresh !== false);

        toggleBodyScroll(true);
    }

    renderUser(id: number | string, props: any) {
        this.props.dispatch(fetchUser(id));
        return <MyProfileContainer {...props}/>;
    }

    saveScrollPosition(cb:(scrollPos:number)=>void) {
        this.scrollEventHandler = () => {                    
            cb(window.pageYOffset);
        };

        window.addEventListener('scroll', this.scrollEventHandler, true);
    }

    render() {
        const {dispatch, initialized, location} = this.props;

        if(StylesRoutes.index() != location.pathname) {         
            window.removeEventListener('scroll', this.scrollEventHandler, true);
        } else {
            this.saveScrollPosition((scrollPosition)=> {                                                
                dispatch(saveScrollPosition(scrollPosition));
            });
        }

        return (
            <div>
                <Route exact path={Api.baseUrl} render={() => {
                    if (currentUserIsLoggedIn())
                        return <Redirect to={FeedsRoutes.index()}/>;
                    else
                        return <Redirect to={SearchRoutes.index()}/>;
                }}/>

                <Route exact path={StylesRoutes.index()} render={(props) => {
                    dispatch(initializeStyles());                    
                    return <MyStylesContainer {...props}/>;
                }}/>

                {/*<Route exact path={StylesRoutes.index() + '/:id'} render={(props) => {*/}
                {/*    let style_id = props.match.params.id;*/}
                {/*    dispatch(initializeStyle(style_id));*/}
                {/*    dispatch(fetchCommentsByStyle(style_id, 1, 10));*/}
                {/*    return <StyleContainer {...props}/>;*/}
                {/*}}/>*/}
                
                <Route exact path={'/:username/styles/:id'} render={(props) => {
                    let style_id = props.match.params.id;
                    dispatch(initializeStyle(style_id));
                    dispatch(fetchCommentsByStyle(style_id, 1, 10));
                    this.rendered = true;
                    return <StyleContainer {...props}/>;
                }}/>

                <Route exact path={ShopsRoutes.index()} render={(props) => {

                    if (this.refresh) {
                        dispatch(refreshShops());
                    }
                    return <ShopListContainer {...props}/>;
                }
                }/>

                <Route exact path={ShopsRoutes.addBooth()} render={(props) => {
                    return <AddBoothContainer {...props}/>;
                }
                }/>

                <Route exact path={ShopsRoutes.viewBooth()} render={(props) => {
                    return <BoothProfileContainer {...props}/>;
                }
                }/>

                <Route exact path={ShopsRoutes.view()} render={(props) => {
                    return <ShopViewContainer {...props}/>;
                }
                }/>

                <Route path={FeedsRoutes.index()} render={(props) => {
                    const query = queryString.parse(props.location.search);
                    const openModal = query.modal as boolean;
                    const selectedFeedId = parseInt(query.feedId);
                    if (!this.pop)
                        dispatch(initializeFeeds(openModal, selectedFeedId));
                    return <ActivityFeedContainer {...props} openModal={openModal}
                                                  selectedFeedId={selectedFeedId}/>;
                }}/>

                <Route exact path={SpecialsRoutes.index()} render={(props) => {
                    if (this.refresh)
                        dispatch(initializeSpecials());
                    return <SpecialsContainer {...props}/>;
                }}/>

                <Route exact path={SpecialsRoutes.index() + '/type/:type'} render={(props) => {
                    const type = props.match.params.type;
                    if (this.refresh)
                        dispatch(initializeSpecialsType(type));
                    return <SpecialsContainer {...props}/>;
                    // let special_id = props.match.params.id;
                    // dispatch(initializeSpecial(special_id));                    
                    // return <SpecialItemContainer {...props}/>;
                }}/>

                <Route exact path={SpecialsRoutes.index() + '/:id'} render={(props) => {
                    let special_id = props.match.params.id;
                    dispatch(initializeSpecial(special_id));
                    return <SpecialItemContainer {...props}/>;
                }}/>

                {/*SHORT URL ROUTE*/}
                {/*<Route path={'/u/:str'} render={(props) => {*/}
                {/*    if(!this.rendered)*/}
                {/*        return this.renderUser(props.match.params.str, props);*/}
                {/*    this.rendered = false;*/}
                {/*    return null;*/}
                {/*}}/>*/}
                <Route exact path={'/:str'} render={(props) => {
                    return this.renderUser(props.match.params.str, props);
                }}/>

                <Route exact path={'/:str/followers'} render={(props) => {
                    if(!this.rendered)
                        return this.renderUser(props.match.params.str, props);
                    this.rendered = false;
                    return null;
                }}/>

                <Route exact path={'/:str/following'} render={(props) => {
                    if(!this.rendered)
                        return this.renderUser(props.match.params.str, props);
                    this.rendered = false;
                    return null;
                }}/>

                {/*ID ROUTE*/}
                <Route path={to_url(Api.baseUrl, 'users', ':id')} render={(props) => {
                    return this.renderUser(props.match.params.id, props);
                }}/>

                {/*<Route path={UsersRoutes.edit_profile()} render={(props) => {*/}
                {/*if (this.refresh) {*/}
                {/*dispatch(initializeUserEdit());*/}
                {/*}*/}
                {/*return <MyProfileEditContainer {...props}/>;*/}
                {/*}}/>*/}

                <Route path={SearchRoutes.index()} render={(props) => {
                    if (!this.pop)
                        dispatch(searchFromUrl(props.location.search));
                    return <SearchContainer {...props}/>;
                }}/>

                <Route exact path={ConversationsRoutes.index()} render={(props) => {                    
                    return <ConversationsContainer {...props}/>;
                }}/>

                <Route exact path={ConversationsRoutes.index() + '/:id/messages'} render={(props) => {
                    let conversationId = props.match.params.id;
                    if (!this.pop)
                        dispatch(initializeConversation(conversationId));
                    return <MessagesContainer {...props}/>;
                }}/>

                <Route path={ConversationsRoutes.index() + '/new'} render={(props) => {
                    const query = queryString.parse(props.location.search);
                    const recipientId = parseInt(query.user_id);
                    if (!this.pop)
                        dispatch(initializeNewConversation(recipientId));
                    return <MessagesContainer {...props}/>;
                }}/>

            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./app/client/dashboard/components/RouterComponent.tsx